module.exports = __webpack_public_path__ + "img/13.43f24004.gif";